import {Injectable} from '@angular/core';
import {ApiService} from './api';
import {Segment} from '../common/flight-search/segment';

@Injectable({providedIn: 'root'})
export class FlightsService {
  path: string = '/api';
  constructor(private apiService: ApiService) {}

  getAirlineSegments(partnerId: any, from: string, to: string, date: string, status: string) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .getParams<Segment[]>(`${this.path}/airlines/${partnerId}/flights`, {
        from: fromFormatted,
        to: toFormatted,
        date: date,
        upa_status: status,
      })
      .toPromise();
  }


  getAirlineSegmentsObservable(partnerId: any, from: string, to: string, date: string) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .getParams<Segment[]>(`${this.path}/v2/airlines/${partnerId}/flights`, {
        from: fromFormatted,
        to: toFormatted,
        date: date,
      });
  }

  getAirlineUtaSegments(from: string, to: string, date: string, airline_ids: number[]) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .getParams<Segment[]>(`${this.path}/flights`, {
        from: fromFormatted,
        to: toFormatted,
        date: date,
        airline_ids: airline_ids,
      })
      .toPromise();
  }
  getThirdPartySegmentsUpas(partnerId: any, from: string, to: string, date: string) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .getParams<Segment[]>(`${this.path}/third_parties/${partnerId}/flights`, {
        from: fromFormatted,
        to: toFormatted,
        date: date,
        include: 'upa_ids',
      });
  }
  getThirdPartySegmentsUtas(from: string, to: string, date: string, airlineIds: number[]) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .getParams<Segment[]>(`${this.path}/flights`, {
        from: fromFormatted,
        to: toFormatted,
        date: date,
        include: 'uta_ids',
        airline_ids: airlineIds,
      })
      .toPromise();
  }
  getRoutes(partnerId: string, from: string, to: string) {
    const fromFormatted = from.toUpperCase();
    const toFormatted = to.toUpperCase();
    return this.apiService
      .get<{ departure_dates: string[] }>(`${this.path}/partners/${partnerId}/routes/${fromFormatted}-${toFormatted}`)
  }
}
